<template>
  <div class="Deduction">
    <div class="Deduction-content">
        <!-- 审批记录 -->
          <div style="overflow: hidden;">
            <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm" label-width="100px">
              <el-form-item label="选择子公司" prop="staffvalue">
                <el-select @change="handleSelect" v-model="ruleForm.son" placeholder="选择子公司">
                  <el-option
                    v-for="item in DataList"
                    :key="item.value"
                    :label="item.companyFullName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开始日期" prop="starttime">
                <el-date-picker
                  class="width1"
                  v-model="ruleForm.starttime"
                  type="date"
                  placeholder="选择开始日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="结束日期" prop="endtime">
                <el-date-picker
                  class="width1"
                  v-model="ruleForm.endtime"
                  type="date"
                  placeholder="选择结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="手机或单据" prop="staffvalue">
                <el-input v-model="input" placeholder></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" style="margin-left: 5px;" class="search">搜索</el-button>
                <el-button type="primary" class="search" @click="searchReset('ruleForm')">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table :data="tableData" :header-cell-style="headClass" border style="width: 100%">
            <el-table-column prop="date" label="公司ID"></el-table-column>
            <el-table-column prop="name" label="单据编号 "></el-table-column>
            <el-table-column prop="address" label="电话"></el-table-column>
            <el-table-column prop="address" label="充值金额"></el-table-column>
            <el-table-column prop="address" label="凭证图片"></el-table-column>
            <el-table-column prop="address" label="备注"></el-table-column>
            <el-table-column prop="address" label="状态"></el-table-column>
            <el-table-column prop="address" label="操作"></el-table-column>
            <el-table-column prop="address" label="操作员"></el-table-column>
            <el-table-column prop="address" label="日期"></el-table-column>
          </el-table>
          <div class="paging">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentpage"
              :page-sizes="[100, 200, 300, 400]"
              :page-size="100"
              layout="total, sizes, prev, pager, next, jumper"
              :total="400"
            ></el-pagination>
          </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Deduction",
  data() {
    return {
      headClass: this.common.headClass,
      radio: "4",
      input: "",
      activeName: "second",
      input3: "",
      currentpage: 1,
      pagesize: 10,
      staff: "",
      checked: true,
      select: "",
      tableData: [
        {
          date: "0.00"
        }
      ],
      sonSearchlist: [
        { value: "公司1" },
        { value: "公司12" },
        { value: "公司13" }
      ],
      ruleForm: {
        son: "", //选择子公司
        starttime: "", //开始时间
        endtime: "" //结束时间
      }
    };
  },
  mounted() {},
  created() {},
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    searchReset(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    // 选择子公司
    sonSearch(queryString, cb) {
      this.common.setOption(queryString, cb, this.sonSearchlist);
    },
    handleSelect(item) {}
  }
};
</script>

<style lang="scss">
.Deduction {
  width: 98%;
  overflow: hidden;
  .Deduction-content {
    margin-top: 20px;
    .el-form-item {
      overflow: hidden;
      width: 18%;
      margin-bottom: 18px;
      float: left;
    }
    .Reportform_tiem {
      overflow: hidden;
      border-top: 1px solid #eee;
      padding: 15px 0;
      .search-result-text {
        font-size: 14px;
        color: #606266;
        padding: 0;
      }
      .el-radio-group {
        display: inline-block;
        line-height: 1;
        vertical-align: middle;
        font-size: 0;
        margin-left: 20px;
      }
    }
    .paging {
      width: 40%;
      margin: 20px auto;
    }
  }
}
</style>
